<template>
  <div v-if="country">
    <country-details :data-country.sync="country" @update:dataCountry="updateCountry" />
    <cash-in-methods class="mt-3" :country_id="id" />
    <cashout-methods class="mt-3" :country_id="id" />
  </div>
</template>

<script>
import CountryDetails from "./details";
import CashInMethods from "./cashInMethods";
import CashoutMethods from "./cashoutMethods";

export default {
  props: {
    id: {
      required: true,
    },
  },
  components: {
    CountryDetails,
    CashInMethods,
    CashoutMethods,
  },
  data: () => ({
    country: null,
  }),
  mounted() {
    this.fetchCountry();
  },
  watch: {
    id() {
      this.fetchCountry();
    },
  },
  methods: {
    fetchCountry() {
      this.$http
        .get(`/api/v1/transactions/cryptoCountries/${this.id}`)
        .then((country) => (this.country = country));
    },
    updateCountry(country) {
      if (country) {
        this.country = country;
      }
    },
  },
};
</script>

<style></style>
